import React from "react";
import "../assests/CSS/BlogComp1.css";
import { blogData } from "./data";

const BlogComp1 = () => {
  return (
    <section className="blog-container">
      <div className="blog-content">
        <h2 className="blog-title">{blogData.title}</h2>
        <p className="blog-description">{blogData.description}</p>
        <a href={blogData.link} className="blog-button">
          {blogData.buttonText}
        </a>
      </div>

      <div className="blog-image">
        {blogData.image ? (
          <img src={blogData.image} alt="Blog" />
        ) : (
          <div className="blog-placeholder"></div>
        )}
      </div>
    </section>
  );
};

export default BlogComp1;
